import { Editor } from '@tiptap/core'

import { PollNode } from './index.js'

export function getEditorPollIds(editor: Editor) {
  return editor
    .$nodes(PollNode.name)
    .map(node => node.attributes?.id)
    .filter(Boolean)
}

/**
 * Extracts poll IDs from stored rich-text content (HTML string).
 * Prefer `getEditorPollIds` when you have a live editor reference — it reads the
 * document model directly. Use this only for serialized content (e.g. seeding
 * defaults from a fetched post) where no editor is mounted. Poll nodes serialize
 * as `<div data-type="poll" data-poll-id="…">`.
 */
export function getContentPollIds(content?: string | null): string[] {
  if (!content) {
    return []
  }
  return [
    ...new Set([...content.matchAll(/data-poll-id="([^"]+)"/g)].map(m => m[1])),
  ]
}
